import './switchAdmin.css';

import * as React from 'react';
import { Redirect } from 'react-router-dom';
import Group from 'src/entities/Group';

interface IProps {
  isAdmin?: boolean;
  group: Group;
}

interface IState {
  isAdmin: boolean;
  switching: boolean;
  switched: boolean;
}

class SwitchAdminComponent extends React.Component<IProps, IState> {
  constructor(props: any) {
    super(props);

    this.state = {
      isAdmin: this.props.isAdmin !== undefined ? this.props.isAdmin : false,
      switching: false,
      switched: false
    };

    this.switch = this.switch.bind(this);
  }

  render() {
    if (this.state.switched) {
      return (
        <Redirect
          to={{
            pathname: this.state.isAdmin
              ? '/' + this.props.group.title + '/memos'
              : '/' + this.props.group.title + '/settings/members',
            state: { from: location.pathname }
          }}
        />
      );
    }

    return (
      <div>
        {(this.state.isAdmin && !this.state.switching) ||
        (!this.state.isAdmin && this.state.switching) ? (
          <div id="SwitchAdmin" onMouseUp={this.switch}>
            <div className="BallAdmin" />
            <div className="ModeAdmin">管理</div>
          </div>
        ) : (
          <div id="SwitchAdmin" onMouseUp={this.switch}>
            <div className="Ball" />
            <div className="Mode">一般</div>
          </div>
        )}
      </div>
    );
  }

  switch(e: any) {
    this.setState({
      switching: true
    });
    setTimeout(() => {
      this.setState({
        switched: true
      });
    }, 200);
  }
}

export default SwitchAdminComponent;



// WEBPACK FOOTER //
// ./src/components/Navigation/switchAdmin.tsx